import AssetSearchRulesCollection from '@netx/core-search/collections/searchRules_assets';
import type {SearchCriteria} from '../types';

/**
 * Convert search rules to backbone search rules collection\
 * For legacy compatability with old backbone code
 * @param conditions
 * @returns Asset search rules collection
 */
export const convertRulesToCollection = (
	conditions: Partial<SearchCriteria>,
) => {
	const ruleCount = conditions.elementTypes?.length;
	if (!ruleCount) return new AssetSearchRulesCollection([]);
	const collection = new AssetSearchRulesCollection(
		(conditions.elementTypes || []).reduce<any[]>(
			(rules, elementType, index) => {
				return [
					...rules,
					{
						elementType,
						elementSubType1: conditions.elementSubType1s![index],
						elementSubType2: conditions.elementSubType2s![index],
						elementValue1: conditions.elementValue1s![index],
						elementValue2: conditions.elementValue2s![index],
						elementValue3: conditions.elementValue3s![index],
					},
				];
			},
			[],
		),
	);
	collection.sortField = conditions.sortField || 'file';
	collection.sortOrder = conditions.sortOrder || 0;
	collection.matchCriteria = conditions.matchCriteria || 0;
	return collection;
};

export default convertRulesToCollection;
